import React from 'react';
import "./CancelButton.css";

export default function CancelButton({ children, ...some }) {

  return <button {...some}>{children}</button>;
}